/* istanbul ignore file */
/**
 * Avatar component theme configuration.
 */

export const avatarComponentConfig = {
  avatar: {
    root: {
      width: '32px',
      height: '32px',
      fontSize: '12px',
      background: '{ultraviolet.100}',
      color: '{ultraviolet.800}',
      borderRadius: '{border.radius.full}',
    },
    icon: {
      size: '20px',
    },
    group: {
      borderColor: '{content.background}',
      offset: '-8px',
    },
    lg: {
      width: '64px',
      height: '64px',
      fontSize: '18px',
      icon: {
        size: '32px',
      },
      group: {
        offset: '-12px',
      },
    },
    xl: {
      width: '64px',
      height: '64px',
      fontSize: '18px',
      icon: {
        size: '32px',
      },
      group: {
        offset: '-16px',
      },
    },
  },
};
